<script setup lang="ts">
  import { authSession } from "@/authentication/authenticationService"
  import { EnrolmentRoute } from "@/constants/routes/enrolment.ts"
  import { MyAccountRoute } from "@/constants/routes/myAccount.ts"
  import { PublicRoute } from "@/constants/routes/public.ts"
  import { useSwitchAccount } from "@/lib/shared/useSwitchAccount"
  import { useNavigationItems } from "@/lib/useNavigationItems.ts"
  import { computed } from "vue"
  import { useRoute } from "vue-router"
  import LogoutButton from "@/components/shared/LogoutButton.vue"
  import { Button } from "@/components/ui/button"
  import { Link } from "@/components/ui/link"

  import { Navbar } from "."

  const { navigationItems, extendedNavigationItems, mobileNavigationItems } =
    useNavigationItems()
  const route = useRoute()
  const { isAuthenticated } = authSession

  const isMaintenanceRoute = computed(
    () => route.path === PublicRoute.maintenance,
  )

  const { hasMultipleAccounts, openSwitchAccount } = useSwitchAccount()
</script>
<template>
  <Navbar
    v-slot="{ closeNavbar }"
    :desktop-navigation-items="navigationItems"
    :tablet-navigation-items="extendedNavigationItems"
    :mobile-navigation-items="mobileNavigationItems"
  >
    <Button
      v-if="!isAuthenticated"
      as-child
      variant="primary"
      data-testid="get-a-quote-button"
      @click="closeNavbar"
    >
      <Link :to="EnrolmentRoute.enrolment">Get a Quote</Link>
    </Button>
    <template v-if="!isMaintenanceRoute">
      <Button
        v-if="hasMultipleAccounts"
        variant="outline"
        class="sm:hidden"
        @click="openSwitchAccount"
      >
        Switch Account
      </Button>
      <LogoutButton v-if="isAuthenticated" variant="outline" />
      <Button v-else as-child variant="outline" @click="closeNavbar">
        <Link :to="MyAccountRoute.login" data-testid="login-button"
          >Account</Link
        >
      </Button>
    </template>
    <Button v-else disabled variant="outline" data-testid="login-button">
      Account
    </Button>
  </Navbar>
</template>
